import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ApplicationLayout from "../../layouts/ApplicationLayout";
import Loader from "../../components/ui/Loader/Loader";
import TapInput from "../../components/ui/TapInput";
import TapSelect from "../../components/ui/TapSelect";
import PaymentFromSelect from "../../services/PayementFromSelect";
import api from "../../services/api";
import tapIcon from "../../services/TapIcon";
import { IAM_API_BASE_URL_2 } from "../../services/TapApiUrls";
import TapHelper from "../../services/TapHelper";
import { toast } from "react-toastify";
import InputExpenseSearch from "../includes/ui/InputExpenseSearch";
import DateService from "../../services/DateService";

const PaymentAdd = ({ location, history, onDataChange }) => {
  const accessToken = useSelector((state) => state.auth.access_token);
  const [loading, setLoading] = useState(false);
  const [submittedFormLoading, setSubmittedFormLoading] = useState(false);
  const [vendorId, setVendorId] = useState("");
  const [isEditMode, setIsEditMode] = useState(false);
  const [paymentId, setPaymentId] = useState(null);

  const [formData, setFormData] = useState({
    paymentModes: [],
    paymentFrom: []
  });
  const [paymentData, setPaymentData] = useState({
    expenseData: null,
    payment_from: "Wallet",
    payment_from_id: "",
    walletData: null,
    payment_mode: "",
    payment_date: moment().format("YYYY-MM-DD"),
    amount: "",
    reference_number: "",
    notes: ""
  });
  const [expenseDetail, setExpenseDetail] = useState(null);
  const [selectAll, setSelectAll] = useState(false);
  const [expenseRows, setExpenseRows] = useState([]);
  const [showExpenseSearch, setShowExpenseSearch] = useState({});

  const fetchFormData = () => {
    api.server2Api
      .get(`${IAM_API_BASE_URL_2}/payment/form_data`, {
        headers: { Authorization: `Bearer ${accessToken}` }
      })
      .then((response) => {
        const { data } = response;
        setFormData({
          paymentModes: (data.payment_mode || []).map((item) => ({
            value: item,
            label: item
          })),
          paymentFrom: (data.payment_from || [])
            .filter(item => item === "Wallet")
            .map((item) => ({
              value: item,
              label: item
            }))
        });
      })
      .catch((error) => {
        console.error("Failed to fetch form data:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const calculateTotalPaidForExpense = (expenseData) => {
    console.log(expenseData);

    if (!expenseData) return 0;
    if (expenseData?.payment?.length > 0) {
      return expenseData.payment.reduce(
        (sum, item) => sum + Number(item?.payment_link?.payment_amount || 0), 0
      );
    }
    else if (expenseData?.payed_amount) {
      return expenseData.payed_amount
    }
    return 0;
  };

  const fetchPaymentDetails = (paymentTransactionId) => {
    setLoading(true);

    api.server2Api
      .get(`/payment/detail/${paymentTransactionId}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      .then((response) => {
        const paymentDetail = response.data;

        fetchFormData();

        setPaymentDataFromApi(paymentDetail);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const setPaymentDataFromApi = (paymentDetail) => {
    let walletData = null;

    if (paymentDetail?.wallet?.id) {
      console.log(paymentDetail?.wallet?.id);

      walletData = {
        value: paymentDetail.wallet.id,
        label: paymentDetail.wallet.wallet_name || `Wallet ${paymentDetail.wallet.id}`,
      };
    }

    setPaymentData(prev => ({
      ...prev,
      payment_from: paymentDetail?.payment_from || "Wallet",
      payment_from_id: paymentDetail?.wallet?.id || "",
      walletData: walletData,
      payment_mode: paymentDetail?.payment_mode || "",
      payment_date: paymentDetail?.payment_date || moment().format("YYYY-MM-DD"),
      amount: paymentDetail?.payment_amount || "",
      reference_number: paymentDetail?.reference_number || "",
      notes: paymentDetail?.notes || "",
    }));

    if (paymentDetail?.payment_link && paymentDetail?.payment_link?.length > 0) {
      const rows = paymentDetail?.payment_link?.map(link => {
        const expense = link.expense;
        const totalPaid = calculateTotalPaidForExpense(expense);

        return {
          id: expense.id || Date.now() + Math.random(),
          expense_date: expense?.expense_date,
          transaction_id: expense?.transaction_id,
          amount: Number(expense?.amount),
          payment_amount: Number(link.payment_amount),
          balance_amount:
            Number(expense?.amount) -
            totalPaid +
            Number(link.payment_amount),
          expense_id: expense?.id,
          expenseData: expense,
          totalPaidForExpense: totalPaid,
          selectedExpense: {
            label: expense?.transaction_id,
            value: expense?.id,
            expense: expense,
          },
          isNew: false,
        };
      });

      setExpenseRows(rows);

      const searchState = {};
      rows.forEach(row => {
        searchState[row.id] = false;
      });
      setShowExpenseSearch(searchState);

      if (rows.length) {
        setVendorId(rows[0].expenseData?.vendor?.id || "");
      }
    }
  };

  useEffect(() => {
    const isEdit = location?.state?.isEdit || false;
    const transactionId = location?.state?.transaction_id || null;
    const expenseData = location?.state?.expenseData || null;

    setIsEditMode(isEdit);
    setPaymentId(transactionId);

    if (isEdit && transactionId) {
      fetchPaymentDetails(transactionId);
    }
    else if (expenseData) {
      setVendorId(expenseData?.vendor?.id);
      const totalPaidForExpense = calculateTotalPaidForExpense(expenseData);

      setExpenseRows([
        {
          id: Date.now(),
          expense_date: expenseData?.expense_date,
          transaction_id: expenseData?.transaction_id,
          amount: expenseData?.amount,
          payment_amount: "",
          balance_amount: Number(expenseData?.amount || 0) - totalPaidForExpense,
          expense_id: expenseData?.id,
          expenseData: expenseData,
          totalPaidForExpense: totalPaidForExpense,
          selectedExpense: {
            label: `${expenseData?.transaction_id}`,
            value: expenseData?.id,
            expense: expenseData
          },
          isNew: false
        },
      ]);
      setShowExpenseSearch({ [Date.now()]: false });
      fetchFormData();
    } else {
      fetchFormData();
    }
  }, [location.state]);

  const addNewExpenseRow = () => {
    const newRowId = Date.now() + Math.random();
    const newRow = {
      id: newRowId,
      expense_date: "",
      transaction_id: "",
      amount: "",
      payment_amount: "",
      balance_amount: 0,
      expense_id: null,
      expenseData: null,
      totalPaidForExpense: 0,
      selectedExpense: null,
      isNew: true
    };

    setExpenseRows([...expenseRows, newRow]);
    setShowExpenseSearch(prev => ({
      ...prev,
      [newRowId]: true
    }));
  };

  const removeExpenseRow = (rowId) => {
    if (expenseRows.length <= 1) {
      toast.warning("Cannot remove the last row");
      return;
    }

    const updatedRows = expenseRows.filter(row => row.id !== rowId);
    setExpenseRows(updatedRows);

    const newShowSearch = { ...showExpenseSearch };
    delete newShowSearch[rowId];
    setShowExpenseSearch(newShowSearch);
  };

  const handleExpenseSelect = (selectedOption, rowIndex) => {
    if (!selectedOption) {
      const rows = [...expenseRows];
      rows[rowIndex] = {
        ...rows[rowIndex],
        expense_date: "",
        transaction_id: "",
        amount: "",
        payment_amount: "",
        balance_amount: 0,
        expense_id: null,
        expenseData: null,
        totalPaidForExpense: 0,
        selectedExpense: null,
        isNew: true
      };
      setExpenseRows(rows);

      const rowId = rows[rowIndex].id;
      setShowExpenseSearch(prev => ({
        ...prev,
        [rowId]: true
      }));
      return;
    }

    const expenseData = selectedOption.expense;
    const rows = [...expenseRows];

    const totalPaidForExpense = calculateTotalPaidForExpense(expenseData);

    rows[rowIndex] = {
      ...rows[rowIndex],
      expense_date: expenseData?.expense_date || "",
      transaction_id: expenseData?.transaction_id || "",
      amount: expenseData?.amount || 0,
      payment_amount: "",
      balance_amount: Number(expenseData?.amount || 0) - totalPaidForExpense,
      expense_id: expenseData?.id || null,
      expenseData: expenseData,
      totalPaidForExpense: totalPaidForExpense,
      selectedExpense: selectedOption,
      isNew: false
    };

    setExpenseRows(rows);

    const rowId = rows[rowIndex].id;
    setShowExpenseSearch(prev => ({
      ...prev,
      [rowId]: false
    }));

    if (rowIndex === 0 && !isEditMode) {
      updatePaymentData({ amount: expenseData?.amount || 0 });
    }
  };

  const toggleExpenseSearch = (rowId) => {
    setShowExpenseSearch(prev => ({
      ...prev,
      [rowId]: !prev[rowId]
    }));
  };

  const updatePaymentData = (newData) => {
    setPaymentData(prev => {
      const updated = { ...prev, ...newData };

      if (onDataChange) {
        onDataChange({
          payment_from: updated.payment_from,
          payment_from_id: updated.payment_from_id,
          payment_mode: updated.payment_mode,
          payment_date: updated.payment_date,
          amount: updated.amount,
          reference_number: updated.reference_number,
          notes: updated.notes,
          payment_from_data: {
            walletData: updated.walletData,
          },
        });
      }

      return updated;
    });
  };

  const handlePaymentFromChange = (data) => {
    updatePaymentData({
      payment_from: data.payment_from || "Wallet",
      payment_from_id: data.payment_from_id || "",
      walletData: data.walletData || null,
    });
  };

  const handlePaymentAmount = (index, value) => {
    let paymentAmount = parseFloat(value);

    if (isNaN(paymentAmount) || value === "") {
      const rows = [...expenseRows];
      const totalPaidForThisExpense = rows[index].totalPaidForExpense || 0;
      const balance = Number(rows[index].amount || 0) - totalPaidForThisExpense;

      rows[index].payment_amount = "";
      rows[index].balance_amount = balance;
      setExpenseRows(rows);

      return;
    }

    const rows = [...expenseRows];
    const totalPaidForThisExpense = rows[index].totalPaidForExpense || 0;
    const expenseBalance = Number(rows[index].amount || 0) - totalPaidForThisExpense;
    const mainPaymentAmount = parseFloat(paymentData.amount || 0);

    const totalTablePayment = rows.reduce((sum, row) => {
      return sum + parseFloat(row.payment_amount || 0);
    }, 0);

    if (paymentAmount > expenseBalance) {
      toast.error(`Payment amount cannot exceed available balance of ${TapHelper.dispayAsAmount(expenseBalance)}`);
      return;
    }
    const newTotal = totalTablePayment - parseFloat(rows[index].payment_amount || 0) + paymentAmount;
    if (newTotal > mainPaymentAmount) {
      toast.error(`Total payment amount cannot exceed main payment amount of ${TapHelper.dispayAsAmount(mainPaymentAmount)}`);
      return;
    }

    rows[index].payment_amount = paymentAmount;
    rows[index].balance_amount = expenseBalance - paymentAmount;
    setExpenseRows(rows);
  };

  const updateField = (field, value) => {
    if (field === "amount") {
      let enteredAmount = parseFloat(value);

      if (isNaN(enteredAmount) || value === "") {
        const rows = [...expenseRows];
        rows.forEach(row => {
          const totalPaidForThisExpense = row.totalPaidForExpense || 0;
          row.payment_amount = "";
          row.balance_amount = Number(row.amount || 0) - totalPaidForThisExpense;
        });
        setExpenseRows(rows);
        updatePaymentData({ amount: "" });
        return;
      }

      const rows = [...expenseRows];
      let isValid = true;

      rows.forEach((row, idx) => {
        const totalPaidForThisExpense = row.totalPaidForExpense || 0;
        const expenseBalance = Number(row.amount || 0) - totalPaidForThisExpense;
        const currentPayment = parseFloat(row.payment_amount || 0);

        if (currentPayment > expenseBalance) {
          toast.error(`Row ${idx + 1} payment exceeds expense balance`);
          isValid = false;
        }
      });

      if (!isValid) return;

      updatePaymentData({ amount: value });

    } else {
      updatePaymentData({ [field]: value });
    }
  };

  const savePayment = () => {
    const invalidRows = expenseRows.some(row => {
      if (!row.expense_id) {
        toast.error("Please select an expense for all rows");
        return true;
      }
      if (!row.amount || Number(row.amount) <= 0) {
        toast.error("Please enter valid amount for all rows");
        return true;
      }
      return false;
    });
    const totalPayment = expenseRows.reduce(
      (sum, row) => sum + Number(row.payment_amount || 0),
      0
    );

    if (totalPayment > Number(paymentData.amount || 0)) {
      toast.error("Expense payment amount cannot exceed main payment amount");
      return;
    }

    if (invalidRows) return;

    const payload = {
      transaction_id: isEditMode ? paymentId : undefined,
      payment_from: paymentData.payment_from,
      payment_from_id: paymentData.payment_from_id,
      payment_mode: paymentData.payment_mode,
      payment_date: paymentData.payment_date,
      amount: paymentData.amount,
      reference_number: paymentData.reference_number,
      notes: paymentData.notes,
      expense_details: expenseRows.map((item) => ({
        expense_id: item.expense_id,
        payment_amount: parseFloat(item.payment_amount || 0),
      })),
    };

    setSubmittedFormLoading(true);

    const url = isEditMode
      ? "/payment/edit"
      : "/payment/add";

    const request = isEditMode
      ? api.server2Api.put(url, payload, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      })
      : api.server2Api.post(url, payload, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

    request
      .then((response) => {
        toast.success(isEditMode ? "Payment updated successfully" : "Payment added successfully");
        history.goBack();
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || "Failed to save payment");
      })
      .finally(() => {
        setSubmittedFormLoading(false);
      });
  };

  const closeEvent = () => {
    history.goBack();
  };

  const renderExpenseDisplay = (item, index) => {
    const expense = item.expenseData;
    if (!expense) return null;

    return (
      <div className="expense-display">
        <div className="fw-bold ">{expense?.transaction_id || "-"}</div>
        <div className="form-text">
          Expense For : <span className="text-capitalize"><b>{expense?.expense_for || "-"}</b></span>
        </div>
        {expense.details && (
          <div className="form-text">
            Notes: <b>{expense?.details}</b>
          </div>
        )}
      </div>
    );
  };

  return (
    <ApplicationLayout>
      <div className="page_title row m0">
        <div className="col-12">
          <h3>{isEditMode ? "Edit Payment" : "Add Payment"}</h3>
          <div className="text-end mt15">
            <button
              onClick={closeEvent}
              type="button"
              className="btn btn-secondary"
            >
              <tapIcon.imageIcon
                icon={tapIcon.CloseIcon}
                className="img-fluid"
                alt="Close Expense"
              />
            </button>
          </div>
        </div>
      </div>

      <div className="container-fluid">
        <div className="page_containt row pl2">
          <div className="pageTbl col-12 pl4">
            {loading ? (
              <Loader />
            ) : (
              <div className="bg-white p-3">
                <div className="tab_content_wrapper mb-3">
                  <span className="content_heading">Payment Details</span>
                </div>
                <div className="row mb-3 align-items-center">
                  <label className="col-sm-3 col-form-label text-left">
                    Payment From
                  </label>
                  <div className="col-sm-4">
                    <PaymentFromSelect
                      value={{
                        payment_from: paymentData.payment_from,
                        payment_from_id: paymentData.payment_from_id,
                        walletData: paymentData.walletData,
                      }}
                      inputClass="col-sm-6"
                      input2Class="col-sm-6"
                      onChange={handlePaymentFromChange}
                      paymentFromOptions={formData.paymentFrom}
                      showWallet={true}
                      required={true}
                      placeholder="Select Payment From"
                      walletPlaceholder="Search Wallet"
                    />
                  </div>
                </div>
                <div className="row mb-3 align-items-center">
                  <label className="col-sm-3 col-form-label text-left">
                    Payment Mode
                  </label>
                  <div className="col-sm-4">
                    <TapSelect
                      options={formData.paymentModes}
                      value={formData.paymentModes.find(
                        (x) => x.value === paymentData.payment_mode
                      )}
                      changeEvent={(selected) =>
                        updateField("payment_mode", selected?.value || "")
                      }
                      isSearchable={true}
                      isClearable={true}
                      placeholder="Select Payment Mode"
                    />
                  </div>
                </div>
                <div className="row mb-3 align-items-center">
                  <label className="col-sm-3 col-form-label text-left require">
                    Amount
                  </label>
                  <div className="col-sm-4">
                    <TapInput
                      className="form-control"
                      type="number"
                      min="0"
                      step="0.01"
                      value={paymentData.amount}
                      onChange={(e) => updateField("amount", e.target.value)}
                      placeholder="Enter Amount"
                      required
                    />
                  </div>
                </div>
                <div className="row mb-3 align-items-center">
                  <label className="col-sm-3 col-form-label text-left require">
                    Payment Date
                  </label>
                  <div className="col-sm-4 add_calender_section">
                    <DatePicker
                      selected={moment(paymentData.payment_date, "YYYY-MM-DD").toDate()}
                      onChange={(date) =>
                        updateField("payment_date", moment(date).format("YYYY-MM-DD"))
                      }
                      maxDate={moment().toDate()}
                      dateFormat="dd-MMM-yyyy"
                      className="form-control"
                      showMonthDropdown
                      showYearDropdown
                      autoComplete="off"
                      required
                      placeholderText="Select Date"
                    />
                    <tapIcon.imageIcon
                      icon={tapIcon.CalenderIcon}
                      alt="payment_date"
                      className="add_calender-icon"
                    />
                  </div>
                </div>
                <div className="row mb-3 align-items-center">
                  <label className="col-sm-3 col-form-label text-left">
                    Reference Number
                  </label>
                  <div className="col-sm-4">
                    <TapInput
                      className="form-control"
                      value={paymentData.reference_number}
                      onChange={(e) => updateField("reference_number", e.target.value)}
                      placeholder="Enter Reference Number"
                    />
                  </div>
                </div>
                <div className="row mb-3 align-items-center">
                  <label className="col-sm-3 col-form-label text-left">Notes</label>
                  <div className="col-sm-4">
                    <textarea
                      className="form-control"
                      value={paymentData.notes}
                      onChange={(e) => updateField("notes", e.target.value)}
                      style={{ height: "60px", fontSize: "93%" }}
                      placeholder="Enter Notes"
                    />
                  </div>
                </div>

                <div className="tab_content_wrapper mb-3 mt-2">
                  <span className="content_heading">Expense Details</span>
                </div>

                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th style={{ width: "20%" }}>Transaction ID</th>
                      <th style={{ width: "13%" }}>Date</th>
                      <th className="text-end" style={{ width: "15%" }}>Total Amount</th>
                      <th className="text-end" style={{ width: "15%" }}>Total Paid</th>
                      <th className="text-end" style={{ width: "15%" }}>Payment Amount</th>
                      <th className="text-end" style={{ width: "15%" }}>Balance Amount</th>
                      <th className="text-center" style={{ width: "7%" }}>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {expenseRows.length > 0 ? (
                      expenseRows.map((item, index) => (
                        <tr key={item.id || index}>
                          <td>
                            {showExpenseSearch[item.id] || !item.selectedExpense ? (
                              <InputExpenseSearch
                                menuPlacement={"top"}
                                changeEvent={(selectedOption) => handleExpenseSelect(selectedOption, index)}
                                value={item.selectedExpense || null}
                                placeholder="Search Expense..."
                                loadDefaultOptions={false}
                                search_vendor_id={vendorId}
                                required={true}
                                isClearable={true}
                                autoFocus={item.isNew}
                              />
                            ) : (
                              renderExpenseDisplay(item, index)
                            )}
                          </td>
                          <td>
                            {item.expense_date ? DateService.dateFormat(item.expense_date) : '-'}
                          </td>
                          <td className="text-end">
                            {item.amount ? TapHelper.dispayAsAmount(item.amount) : '-'}
                          </td>
                          <td className="text-end">
                            {item.totalPaidForExpense > 0 ? item.totalPaidForExpense : '0'}
                          </td>
                          <td className="text-end">
                            <TapInput
                              type="number"
                              className="form-control form-control-sm text-end"
                              value={item.payment_amount || ""}
                              onChange={(e) => handlePaymentAmount(index, e.target.value)}
                              placeholder="0.00"
                              style={{ textAlign: 'right' }}
                              disabled={!item.expense_id}
                            />
                          </td>
                          <td className="text-end">
                            {item.balance_amount !== undefined && item.balance_amount !== null
                              ? item.balance_amount
                              : '-'}
                          </td>
                          <td className="text-center align-middle">
                            {expenseRows.length > 1 && (
                              <a
                                href="#"
                                onClick={(e) => {
                                  e.preventDefault();
                                  removeExpenseRow(item.id);
                                }}
                                className="text-danger"
                                style={{ cursor: 'pointer' }}
                                title="Remove Row"
                              >
                                <tapIcon.imageIcon
                                  icon={tapIcon.CloseCircleIcon}
                                  className="img-fluid"
                                  style={{ width: '20px', height: '20px' }}
                                />
                              </a>
                            )}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr className="text-center">
                        <td colSpan={7}>No Record Found</td>
                      </tr>
                    )}
                  </tbody>
                </table>

                <div className="row mb-3">
                  <div className="col-12 text-end">
                    <a
                      role="button"
                      onClick={addNewExpenseRow}
                      className="link-primary"
                      style={{ cursor: 'pointer' }}
                    >
                      <tapIcon.FontAwesomeIcon icon={tapIcon.faPlus} /> Add Row
                    </a>
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-12 text-end mb-2">
                    <button
                      className="btn btn-primary"
                      onClick={savePayment}
                      disabled={submittedFormLoading}
                    >
                      {submittedFormLoading && (
                        <tapIcon.FontAwesomeIcon
                          icon={tapIcon.faSyncAlt}
                          className="fa-spin"
                        />
                      )} {isEditMode ? "Update" : "Save"}
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </ApplicationLayout>
  );
};

export default PaymentAdd;